<template>
  <span
    class="badge padding-left-xxs padding-right-xxs grid-x align-middle menu-link-sm"
  >{{ label }}
    <button
      :aria-label="`show tooltip for ${label} badge`"
      @click="toggleTooltip"
    >
      <span class="tooltip-small" />
    </button>
  </span>
  <ToggleTip
    ref="tooltipRef"
    position="right"
    append-to="self"
    :width="210"
  >
    <p>{{ tooltipBody }}</p>
  </ToggleTip>
</template>

<script setup>
import { ref } from 'vue';
import ToggleTip from '@atomic-ui/toggletip';

defineProps({
  label: {
    type: String,
    required: true,
  },
  tooltipBody: {
    type: String,
    required: true,
  },
});

const tooltipRef = ref(null);
const toggleTooltip = (e) => {
  if (tooltipRef.value?.toggle) {
    const { currentTarget } = e;
    tooltipRef.value.toggle({ currentTarget });
  }
};

</script>
<style lang="scss" scoped>
@import "~settingSCSS";
@import "@csgIcons/_tooltip-small.scss";

.badge {
  background-color: $hover-color;
  position: relative;
}
</style>
